export enum OriginalTextIconPosition {
  START = 'start',
  END = 'end',
}
